import { useTranslation } from "react-i18next";
import { CartRow } from "types/cart";
import { Text } from "@caspeco/casper-ui-library.components.text";
import {
	ThemeColorVariable,
	ThemeFontSizeVariable,
	ThemeFontVariable,
	ThemeIconSizeVariable,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library.base-ui.theme";
import { Flex } from "@caspeco/casper-ui-library.components.flex";
import CartRowDiscount from "components/single-cart-row/subcomponents/CartRowDiscount";
import { Icon, Icons } from "@caspeco/casper-ui-library.components.icon";
import { useCartStore } from "store/cartStore";
import SingleCartRow from "components/single-cart-row/SingleCartRow";
import { StyledCartRows } from "../Cart.styles";

export function CartRows({ onClickCartRow }: { onClickCartRow: (cartRow: CartRow) => void }) {
	const { t } = useTranslation();
	const { cart } = useCartStore();

	const rows = cart?.rows ?? [];
	const campaignDiscounts = cart?.campaigns.discounts ?? [];

	if (!cart || cart?.isEmpty())
		return (
			<Flex
				mt="86px"
				direction="column"
				p={ThemeSpaceVariable.Medium}
				id="cart"
				align="center"
				h="100%"
				justify="flex-start"
			>
				<Icon
					icon={Icons.Cart}
					size={ThemeIconSizeVariable.X3Large}
					mb={ThemeSpaceVariable.Large}
					color={ThemeColorVariable.OnSurfaceBorder}
				/>
				<Text
					align="center"
					fontWeight="medium"
					fontSize={ThemeFontSizeVariable.Large}
					fontFamily={ThemeFontVariable.SubHeader}
					color={ThemeColorVariable.OnSurfaceHeader}
				>
					{t("purchase_cart_empty")}
				</Text>
				<Text
					align="center"
					id="emptycart-desc"
					px={ThemeSpaceVariable.Medium}
					color={ThemeColorVariable.OnSurface}
				>
					{t("purchase_cart_empty_description")}
				</Text>
			</Flex>
		);
	return (
		<StyledCartRows id="cart">
			{rows.map((row, i) => {
				const isLastRow = i === rows.length - 1;
				const hasCampaignDiscount = campaignDiscounts.length > 0;
				const borderBottom = !isLastRow || hasCampaignDiscount;
				return (
					<SingleCartRow key={row.id} row={row} onClickCartRow={onClickCartRow} borderBottom={borderBottom} />
				);
			})}
			{campaignDiscounts.map((discount, i) => {
				const isLastRow = i === campaignDiscounts.length - 1;
				const borderBottom = !isLastRow;
				return <CartRowDiscount discount={discount} key={i} borderBottom={borderBottom} />;
			})}
		</StyledCartRows>
	);
}
